import { useEffect, useState } from 'react';
// import { API_BASE_URL } from '../../constants';
import { API_GRAPHQL } from '../../constants';
import { axiosAuthFetch } from '../../helpers/apiActions/authFetch';

// export function useRetrieveProducts() {
//     const url = `${API_BASE_URL}/products?populate=*`;
//     const [products, setProducts] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isError, setIsError] = useState(false);

//     useEffect(() => {
//         async function getProducts(url) {
//             try {
//                 setIsLoading(true);
//                 setIsError(false);

//                 const response = await fetch(url);
//                 const products = await response.json();
//                 console.log(products.data);
//                 setProducts(products.data);
//             } catch(error) {
//                 console.log(error);
//                 setIsError(true);
//             } finally {
//                 setIsLoading(false);
//             }
//         }

//         getProducts(url);
//     }, [url]);
//     return { products, isLoading, isError};
// }

// export default useRetrieveProducts;

export function useRetrieveProductsGraphQL() {
    const url = `${API_GRAPHQL}`;
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [ isError, setIsError] = useState(false);

    useEffect(() => {
        async function getProducts(url) {
            try {
                setIsLoading(true);
                setIsError(false);
                
                const query = `query {
                    products(pagination:{limit:900}){
                              data{
                                  id
                                  attributes{
                                             service_form{
                                              data{
                                                  id
                                                  attributes{
                                                      visual_check
                                                      service_checks{
                                                          data{
                                                              id
                                                              attributes{
                                                                  navn
                                                                  description
                                                                  category
                                                                  service_action{
                                                                      data{
                                                                          id
                                                                          attributes{
                                                                              description
                                                                          }
                                                                      }
                                                                  }
                                                              }
                                                          }
                                                      }
                                                  }
                                              }
                                             }
                                             name
                                             visible
                                             description
                                             price
                                             varenummer
                                             image{
                                              data{
                                                  attributes{
                                                      url
                                                  }
                                              }
                                             }
                                             category{
                                              data{
                                                  id
                                                  attributes{
                                                      place
                                                  }
                                              }
                                             }
                                             product_information{
                                                id
                                                infoText
                                                infoValue
                                             }
                                             multipleVoltages
                                             voltageOptions{
                                                voltage
                                             }
                                             supplier{
                                                      data{
                                                          id
                                                          attributes{
                                                                     name
                                                                    }
                                                          }
                                                      }
                                              }
                                  }
                              }
                      }`;
                const products = await axiosAuthFetch(url, { query }, 'POST');
                // const products = await response.json();
                console.log('PRODUCTSRESPONSE', products.data.products.data);
                setProducts(products.data.products.data);
            } catch(error) {
                console.log(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        getProducts(url);
    }, [url]);
    return {products, isLoading, isError}
}

export default useRetrieveProductsGraphQL;
